import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CloseCircleFilledIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "close-circle-filled",
  "CloseCircleFilledIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M8.00016 1.33337C4.31827 1.33337 1.3335 4.31814 1.3335 8.00004C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00004C14.6668 4.31814 11.6821 1.33337 8.00016 1.33337ZM5.40721 9.65022L4.93581 10.1216L5.87862 11.0644L6.35002 10.593L8.00017 8.94288L9.64985 10.5926L10.1213 11.064L11.0641 10.1212L10.5927 9.64977L8.94298 8.00008L10.5927 6.35039L11.0641 5.87898L10.1213 4.93617L9.64985 5.40758L8.00017 7.05727L6.35002 5.40712L5.87862 4.93572L4.93581 5.87853L5.40721 6.34993L7.05736 8.00008L5.40721 9.65022Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default CloseCircleFilledIcon;
